import intlTelInput, {  Plugin }  from 'intl-tel-input';
import { Component, JSX, h, Host, Prop, ComponentDidLoad, State, Event, EventEmitter, Watch } from '@stencil/core';
import { store } from '../../utils/store';
import { COUNTRY_CODES_LOWERCASE, MESSAGES } from '../constants';
import { CountriesEnum } from '../../generated/operations';
import { ConfigQuery } from '../../generated/operations';

const errorMap = [
  MESSAGES.INVALID_NUMBER,
  MESSAGES.INVALID_COUNTRY_CODE,
  MESSAGES.TOO_SHORT,
  MESSAGES.TOO_LONG,
  MESSAGES.INVALID_NUMBER
];

@Component({
  tag: 'tel-input',
  shadow: false,
})
export class TelInput implements ComponentDidLoad {
  @Prop() name: string;
  @Prop() countryCode: CountriesEnum;

  @State() error: keyof ConfigQuery["i18n"] | null = null;
  @Event() telInputChange?: EventEmitter<string>;
  @Event() telInputValid?: EventEmitter<boolean>;
  private input!: HTMLInputElement;
  private instance?:Plugin;

  public render(): JSX.Element {
    return (
      <Host>
        <input
          ref={(ref) => this.input = ref}
          required={true}
          type="tel"
          name={this.name}
          onBlur={() => this.blur()}
        />
        {this.error && this.error.length > 0 && <div class="form-group__error">
          <belimo-i18n messageId={this.error}/>
        </div>}
      </Host>
    )
  }

  @Watch('countryCode')
  public watchCountry(value: CountriesEnum | null) {
    if (value === null) {
      return;
    }
    this.instance?.setCountry(value.toLowerCase());
    this.countryCode = value;
  }

  public async componentWillLoad(): Promise<void> {
    this.watchCountry(this.countryCode);
  }

  public blur(): void {
      this.error = null;
      if (this.input.value.trim().length > 0) {
        if (!this.instance.isValidNumber()) {
          this.error = errorMap[this.instance.getValidationError()] || MESSAGES.INVALID_NUMBER;
          this.telInputValid.emit(false);
        } else {
          this.telInputChange.emit(this.instance.getNumber())
          this.telInputValid.emit(true);
        }
      } else {
        this.telInputChange.emit('')
        this.telInputValid.emit(true);
      }
  }
  public componentDidLoad(): void {
    this.init();
    this.watchCountry(this.countryCode);
  }

  private init(): void {
    this.instance = intlTelInput(this.input, {
      initialCountry: this.countryCode.toLowerCase(),
      onlyCountries: COUNTRY_CODES_LOWERCASE,
      separateDialCode: false,
      utilsScript: `${store.state.cdnUri}js/utils.js`,
    });
  }

  private destroy(): void {
    if (this.instance) {
      this.instance.destroy();
    }
  }

  public disconnectedCallback(): void {
    this.destroy();
  }
}
